<template>
  <div :class="['app-consumption-item', 'tariff-' + tariffId]">
    <dyn-slot :slot-data="consumption">
      <slot :name="`txtBeforeConsumption${consumption.type}`" class="label-span">{{consumption.type}}</slot>
    </dyn-slot>
    <div v-if="consumptionTitle" class="unit-labels consumption-title">
      <span class="min-label">0</span>
      <span class="max-label">{{ formatNumber(consumption.max) }}</span>
    </div>
    <b-progress :max="consumption.max" class="consumption-progress">
      <b-progress-bar :value="consumption.left">
        <div class="consumption-info">
          {{ formatNumber(consumption.consumed) }} von {{ formatNumber(consumption.max) }} <Unit :unit="consumption.unit"/> verbraucht
        </div>
      </b-progress-bar>
      <div class="consumption-info">
        {{ formatNumber(consumption.left) }} von {{ formatNumber(consumption.max) }} <Unit :unit="consumption.unit"/> übrig
      </div>
    </b-progress>
    <!-- Erweiterungsmöglichkeit: wenn consumption.tariffOrOptions nicht leer ist, kann hier eine entsprechende -->
    <!-- Komponente eingebunden werden -->
    <slot :name="`txtAfterConsumption${consumption.type}`">
      <div class="consumption-info">
        {{ formatNumber(consumption.consumed) }} <span class="consumption-unit"><Unit :unit="consumption.unit"/></span> von {{ formatNumber(consumption.max) }} <Unit :unit="consumption.unit"/> verbraucht
      </div>
    </slot>
  </div>
</template>

<script>

import Unit from '../Unit.vue'
import slotProxy from '../../../../../mixins/slotProxy'
export default {
  components: { Unit },
  props: {
    consumption: {
      type: Object,
      default: () => {}
    },
    tariffId: {
      type: String,
      default: ''
    },
    consumptionTitle: {
      type: Boolean,
      default: true
    }
  },
  mixins: [
    slotProxy()
  ],
  name: 'ConsumptionItemProgress',
  methods: {
    formatNumber (number) {
      if (this.$config?.calendar?.formatter?.numberFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.numberFormatter.format(number)
    }
  }
}
</script>
